import { Injectable } from '@angular/core';
import { FiltersDetail } from '../../app/modules/chart/interface/interfaces';
import { Actions, AppStore } from '../index';
import { ReduxAction, ReduxType } from '../interface';

@Injectable()
export class FilterActions extends Actions {
  constructor(appStore: AppStore) {
    super(appStore);
  }

  public storeFilter(filter: FiltersDetail): ReduxAction<FiltersDetail> {
    return { type: ReduxType.FILTER_TABLE, payload: filter };
  }
}
